import PasswordInput from '../components/PasswordInput';
import React, { useState, useEffect } from 'react';
import axios from 'axios';

const SifreSifirlaPage = ({ token, geriDon }) => {
  const [adim, setAdim] = useState('dogrula'); // dogrula | sifirla | tamamlandi | hata
  const [email, setEmail] = useState('');
  const [yeniSifre, setYeniSifre] = useState('');
  const [tekrar, setTekrar] = useState('');
  const [mesaj, setMesaj] = useState('');
  const [yukleniyor, setYukleniyor] = useState(false);

  useEffect(() => {
    if (token) {
      axios.get('/api/sifre/dogrula/' + token)
        .then(r => { setEmail(r.data.email); setAdim('sifirla'); })
        .catch(err => { setMesaj(err.response?.data?.hata || 'Geçersiz bağlantı.'); setAdim('hata'); });
    }
  }, [token]);

  const handleSifirla = async (e) => {
    e.preventDefault();
    if (yeniSifre !== tekrar) { setMesaj('Şifreler eşleşmiyor.'); return; }
    setYukleniyor(true); setMesaj('');
    try {
      await axios.post('/api/sifre/sifirla', { token, yeni_sifre: yeniSifre });
      setAdim('tamamlandi');
    } catch(err) { setMesaj(err.response?.data?.hata || 'Hata oluştu.'); }
    finally { setYukleniyor(false); }
  };

  return (
    <div className="giris-wrap">
      <div className="giris-kart">
        <div className="giris-logo">
          <div className="ikon">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#1a56db" strokeWidth="1.5">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0110 0v4"/>
            </svg>
          </div>
          <h1>Valure HR</h1>
        </div>

        {adim === 'dogrula' && (
          <div style={{ textAlign: 'center', padding: '1rem', color: 'var(--yazi-ikincil)' }}>
            Bağlantı doğrulanıyor...
          </div>
        )}

        {adim === 'sifirla' && (
          <>
            <h2 style={{ fontSize: '18px', marginBottom: '0.5rem' }}>Yeni Şifre Belirle</h2>
            <p style={{ fontSize: '13px', color: 'var(--yazi-ikincil)', marginBottom: '1.5rem' }}>{email}</p>
            {mesaj && <div className="alert alert-error" style={{ marginBottom: '1rem' }}>{mesaj}</div>}
            <form onSubmit={handleSifirla} style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
              <div className="form-group">
                <label>Yeni Şifre *</label>
                <PasswordInput value={yeniSifre} /> setYeniSifre(e.target.value)} required minLength={6} placeholder="En az 6 karakter" />
              </div>
              <div className="form-group">
                <label>Yeni Şifre (Tekrar) *</label>
                <PasswordInput value={tekrar} /> setTekrar(e.target.value)} required placeholder="Şifreyi tekrar girin" />
              </div>
              <button type="submit" className="btn btn-primary" disabled={yukleniyor} style={{ width: '100%', padding: '0.75rem' }}>
                {yukleniyor ? 'Güncelleniyor...' : 'Şifremi Güncelle'}
              </button>
            </form>
          </>
        )}

        {adim === 'tamamlandi' && (
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '48px', marginBottom: '1rem' }}>✓</div>
            <h2 style={{ fontSize: '18px', marginBottom: '0.5rem', color: 'var(--yesil)' }}>Şifreniz Güncellendi!</h2>
            <p style={{ fontSize: '14px', color: 'var(--yazi-ikincil)', marginBottom: '1.5rem' }}>Yeni şifrenizle giriş yapabilirsiniz.</p>
            <button className="btn btn-primary" style={{ width: '100%', padding: '0.75rem' }} onClick={geriDon}>
              Giriş Sayfasına Dön
            </button>
          </div>
        )}

        {adim === 'hata' && (
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '48px', marginBottom: '1rem' }}>✗</div>
            <h2 style={{ fontSize: '18px', marginBottom: '0.5rem', color: 'var(--kirmizi)' }}>Geçersiz Bağlantı</h2>
            <p style={{ fontSize: '14px', color: 'var(--yazi-ikincil)', marginBottom: '1.5rem' }}>{mesaj}</p>
            <button className="btn btn-secondary" style={{ width: '100%', padding: '0.75rem' }} onClick={geriDon}>
              Giriş Sayfasına Dön
            </button>
          </div>
        )}
      </div>
    </div>
  );
};
export default SifreSifirlaPage;
